export default __webpack_public_path__ + "static/media/pin2.9b03b1e6.svg";